<template>
  <div>
    <div
      @click="toggleDropdown"
    >
      <feather-icon
        id="taskBoardNotificationPopover"
        ref="taskBoardNotificationDropdownTrigger"
        :badge="unReadNotifications"
        badge-classes="bg-warning"
        class="text-body text-warning dropdown-notification mr-25"
        icon="CheckSquareIcon"
        size="21"
      />
    </div>

    <b-popover
      ref="taskBoardNotificationDropdown"
      :key="unReadNotifications"
      target="taskBoardNotificationPopover"
      triggers="focus"
      placement="bottomright"
      custom-class="task-board-notification-popover list-group"
      @shown="notificationShown = true"
      @hidden="notificationShown = false"
      @refetch="getTaskNotifications(false)"
    >
      <task-board-notification-body @close-dropdown="toggleDropdown" />
    </b-popover>

    <b-modal
      id="tb-mark-all-as-read"
      title="Mark All Task &amp; Board Notifications as Read"
      ok-title="Confirm"
      ok-variant="success"
      ok-only
      hide-cancel
      no-close-on-backdrop
      @ok="markAllAsRead"
    >
      <p>
        Are you sure you want to mark all task &amp; board notifications as read?
      </p>
    </b-modal>
  </div>
</template>

<script>
import { BPopover, BModal } from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import TaskBoardNotificationBody from './TaskBoardNotificationBody.vue'

export default {
  components: {
    TaskBoardNotificationBody,
    BPopover,
    BModal,
  },
  data() {
    return {
      notificationShown: false,
    }
  },
  computed: {
    unReadNotifications() {
      return this.$store.state.taskBoardNotification.unReadNotifications > 0
        ? this.$store.state.taskBoardNotification.unReadNotifications
        : 0
    },
  },
  mounted() {
    this.getTaskNotifications(true)
  },
  methods: {
    markAllAsRead() {
      const project = this.$store.state.project?.project
      useApollo.users.markAllNotificationsAsRead({ projectUid: project.uuid }).then(() => {
        this.$store.dispatch('taskBoardNotification/setUnreadNotifications', 0)
      })
    },
    toggleDropdown() {
      if (this.notificationShown) {
        this.$root.$emit('bv::hide::popover', 'taskBoardNotificationPopover')
        this.notificationShown = false
        this.$refs.taskBoardNotificationDropdownTrigger.blur()
      } else {
        this.$refs.taskBoardNotificationDropdownTrigger.focus()
        this.$root.$emit('bv::show::popover', 'taskBoardNotificationPopover')
      }
    },
    async getTaskNotifications(initial = false) {
      this.showSkeleton = initial
      this.isProcessing = true
      const project = this.$store.state.project?.project
      await this.$store.dispatch('taskBoardNotification/fetchNotifications', { projectUid: project.uuid })
      this.isProcessing = false
      this.showSkeleton = false
    },
  },
}
</script>

<style lang="scss">
.task-board-notification-popover {
  max-width: 30vw !important;
  width: 30vw !important;

  .arrow:after {
    border-bottom-color: #ffc107 !important;
  }

  .popover-body {
    padding: 0;
    border-top: 0px solid #ffc107;
    border-radius: 6px 6px 0 0 !important;

    .notification-card.notification-card--active{
      background-color: #f8f8f8;
    }
  }
}

.dark-layout {
  .task-board-notification-popover {
    .popover-body {
      .notification-card.notification-card--active{
        background-color: #161d31;
      }
    }
  }
}
</style>
